<template>
  <LoadingScreen v-if="!$store.state.brandPage" />
  <div>
    <TsHero />
    <div>
      <BrandsLogos />
    </div>
    <div class="ts-container-fluid container-fluid">
      <HarnessPower />
      <HowItWorks />
    </div>
    <BrandLoves v-bind:haveGradient="false" v-if="$store.state.brandPage">
      <h3 class="ts-fs-1 ts-text-gray-5 text-center fw-bold mb-08 mb-lg-13">
        {{ $store.state.brandPage.Testimonial.title }}
        <span class="ts-text-primary-1">{{
          $store.state.brandPage.Testimonial.titleHighlighted
        }}</span>
        <br class="d-sm-none" />
        {{ $store.state.brandPage.Testimonial.title2 }}
      </h3>
    </BrandLoves>
    <div class="ts-container-fluid container-fluid">
      <LastestNews>
        <h3
          class="ts-fs-1 ts-text-gray-5 text-center fw-bold mb-08 mb-lg-13"
          v-if="$store.state.brandPage"
        >
          {{ $store.state.brandPage.BlogSectionTitle }}
        </h3>
      </LastestNews>
    </div>
  </div>
</template>

<script>
import LoadingScreen from "../components/Common/LoadingScreen.vue";
import TsHero from "../components/Brands/TsHero.vue";
import BrandsLogos from "../components/Common/BrandsLogos.vue";
import HarnessPower from "../components/Brands/HarnessPower.vue";
import HowItWorks from "../components/Brands/HowItWorks.vue";
import BrandLoves from "../components/Common/BrandLoves.vue";
import LastestNews from "../components/Common/LastestNews.vue";
import { useHead } from "@vueuse/head";
import { metaConfig } from "../config/meta";

export default {
  name: "BrandsPage",
  components: {
    LoadingScreen,
    TsHero,
    BrandsLogos,
    HarnessPower,
    HowItWorks,
    BrandLoves,
    LastestNews,
  },

  setup() {
    useHead({
      // Set the title
      title: metaConfig.brands.title,
      // Set all meta tags
      meta: [
        // Regular meta tags
        ...metaConfig.brands.meta
          .filter((meta) => meta.name)
          .map((meta) => ({
            name: meta.name,
            content: meta.content,
            key: meta.name,
          })),
        // OpenGraph meta tags
        ...metaConfig.brands.meta
          .filter((meta) => meta.property)
          .map((meta) => ({
            property: meta.property,
            content: meta.content,
            key: meta.property,
          })),
      ],
      // Set link tags (like canonical)
      link: [
        ...metaConfig.brands.meta
          .filter((meta) => meta.rel)
          .map((meta) => ({
            rel: meta.rel,
            href: meta.href,
            key: "canonical",
          })),
      ],
    });

    return {};
  },

  computed: {
    activeLanguage() {
      return this.$store.getters.activeLanguage;
    },
  },

  // Watch if ACtive language Change but not same as old Language
  watch: {
    activeLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$store.dispatch("getBrandPage");
      }
    },
  },
  created() {
    this.$store.dispatch("getBrandPage");
  },
};
</script>
